import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  'townsquare.api.goal-type-name.goal': {
    id: 'townsquare.api.goal-type-name.goal',
    defaultMessage: 'Goal',
    description: 'Title of goal'
  },
  'townsquare.api.goal-type-name.objective': {
    id: 'townsquare.api.goal-type-name.objective',
    defaultMessage: 'Objective',
    description: 'Title of an objective'
  },
  'townsquare.api.goal-type-name.key-result': {
    id: 'townsquare.api.goal-type-name.key-result',
    defaultMessage: 'Key Result',
    description: 'Title of a key result'
  },
  goalTypeSelectPlaceholder: {
    id: 'townsquare.packages.create-goal-modal.type-label-placeholder',
    defaultMessage: 'What should we call this?',
    description: 'Type placeholder'
  }
});
export var isMessageId = function isMessageId(id) {
  return id !== undefined && id !== null && id in messages;
};